import {
  type ComplianceViolationRemoveInput,
  type ComplianceViolationRemoveSuccess,
  toResponseError,
} from '@terros/common'
import { type RemoveHookResponse, mutationRemove } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useQueryClient } from '@tanstack/react-query'
import { complianceViolationKey, complianceViolationsKey } from '../../keys'

export function useRemoveComplianceViolation(): RemoveHookResponse<ComplianceViolationRemoveInput> {
  const queryClient = useQueryClient()

  const mutation = useTantalimMutation<ComplianceViolationRemoveInput, ComplianceViolationRemoveSuccess>({
    url: '/compliance/violation/remove',
  })

  async function remove(input: ComplianceViolationRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: complianceViolationsKey() }),
        queryClient.removeQueries({ queryKey: complianceViolationKey(input.violationId) }),
      ])
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
